// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { themr } from "react-css-themr";
import { Tabs, itemList } from "@lifepay/rc-ui-toolkit";
import { withRouter } from "react-router";
import { connect } from "react-redux";

// ABSOLUTE PATH IMPORTS
import selectors from "model/selectors";
import User from "components/list-items/User";
import ProcessingUser from "components/list-items/ProcessingUser";
import ProcessingRole from "components/list-items/ProcessingRole";

// RELATIVE PATH IMPORTS
import CreateUser from "../Users/CreateUser";
import CreateProcUser from "../Users/CreateProcUser";
import CreateProcRole from "../Users/CreateProcRole";
import styles from "./Users.m.scss";

import { users, processingUsers, processingRoles } from "model/gql/queries";
const UsersData = itemList.QueryFactory(users);
const ProcUsersData = itemList.QueryFactory(processingUsers);
const AllRolesData = itemList.QueryFactory(processingRoles);
const ProcRolesData = itemList.QueryFactory(processingRoles);

@withRouter
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      roles: selectors.user.roles$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {}
)
@themr("Users", styles)
export default class Users extends Component {
  static propTypes = {
    theme: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    roles: PropTypes.object,
    children: PropTypes.node,
    basePath: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      usersExtendedView: true,
    };
  }

  render() {
    const { theme, basePath, roles, history, match } = this.props;
    const { usersExtendedView } = this.state;
    const route = match.params.subdir;
    let activeTab = null;
    switch (route) {
      case "users": {
        activeTab = "USERS";
        break;
      }
      case "proc-users": {
        activeTab = "PROC_USERS";
        break;
      }
      case "proc-roles": {
        activeTab = "PROC_ROLES";
        break;
      }
      default: {
        activeTab = "USERS";
      }
    }

    return (
      <div className={classnames(theme.wrapper)}>
        <Tabs
          activeTab={activeTab}
          tabs={[
            {
              id: "USERS",
              component: "Пользователи SSO",
              onClick: () => {
                history.push(`${basePath}/users`);
              },
            },
            {
              id: "PROC_USERS",
              component: "Пользователи процессинга",
              onClick: () => {
                history.push(`${basePath}/proc-users`);
              },
            },
            {
              id: "PROC_ROLES",
              component: "Роли процессинга",
              onClick: () => {
                history.push(`${basePath}/proc-roles`);
              },
            },
          ]}
        >
          {({ activeTab }) => {
            switch (activeTab) {
              case "USERS": {
                return (
                  <itemList.List
                    key={"USERS"}
                    history={history}
                    location={location}
                    dataComponent={UsersData}
                    filtersConfig={[
                      {
                        key: "username",
                        label: "Логин",
                        type: "string",
                      },
                      {
                        key: "lastName",
                        label: "Фамилия",
                        type: "string",
                      },
                      {
                        key: "email",
                        label: "Email",
                        type: "string",
                      },
                      {
                        key: "showAll",
                        label: "Показать всех",
                        type: "bool",
                        default: "false",
                        required: true,
                      },
                    ]}
                  >
                    {(listProps) => {
                      return (
                        <React.Fragment>
                          <itemList.Controls {...listProps} />
                          <div className={classnames(theme.controls)}>
                            <CreateUser />
                          </div>
                          <itemList.Results
                            {...listProps}
                            Item={User}
                            ItemProps={{
                              currentUserRoles: roles,
                              extendedView: usersExtendedView,
                              updateQuery: listProps.updateQuery,
                            }}
                          />
                        </React.Fragment>
                      );
                    }}
                  </itemList.List>
                );
              }
              case "PROC_USERS": {
                return (
                  <itemList.List
                    key={"PROC_USERS"}
                    history={history}
                    location={location}
                    dataComponent={ProcUsersData}
                    filtersConfig={[
                      {
                        key: "username",
                        label: "Имя пользователя",
                        type: "string",
                      },
                      {
                        key: "isBlocked",
                        label: "Заблокирован",
                        type: "bool",
                      },
                    ]}
                  >
                    {(listProps) => {
                      return (
                        <React.Fragment>
                          <itemList.Controls {...listProps} />
                          <div className={classnames(theme.controls)}>
                            <CreateProcUser
                              onSuccess={(responce, { username }) => {
                                listProps.setFilters({
                                  username,
                                });
                                listProps.handleFetch();
                              }}
                            />
                          </div>
                          <AllRolesData variables={{}}>
                            {({ data, dataState }) => (
                              <itemList.Results
                                {...listProps}
                                usePaginator={true}
                                // Header={CompanyHeader}
                                Item={ProcessingUser}
                                ItemProps={{
                                  roles: data,
                                  rolesDataState: dataState,
                                  refetchUsers: listProps.handleRefetch,
                                  updateQuery: listProps.updateQuery,
                                }}
                              />
                            )}
                          </AllRolesData>
                        </React.Fragment>
                      );
                    }}
                  </itemList.List>
                );
              }
              case "PROC_ROLES": {
                return (
                  <itemList.List
                    key={"PROC_ROLES"}
                    useDataComponent
                    history={history}
                    location={location}
                    dataComponent={ProcRolesData}
                    filtersConfig={[
                      {
                        key: "roleName",
                        label: "Название роли",
                        type: "string",
                      },
                    ]}
                  >
                    {(listProps) => (
                      <React.Fragment>
                        <itemList.Controls {...listProps} />
                        <div className={classnames(theme.controls)}>
                          <CreateProcRole
                            onSuccess={(responce, { role }) => {
                              listProps.setFilters({
                                roleName: role,
                              });
                              listProps.handleFetch();
                            }}
                          />
                        </div>
                        <itemList.Results
                          {...listProps}
                          usePaginator={true}
                          // Header={CompanyHeader}
                          Item={ProcessingRole}
                          ItemProps={{
                            updateQuery: listProps.updateQuery,
                          }}
                        />
                      </React.Fragment>
                    )}
                  </itemList.List>
                );
              }
            }
          }}
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-admin/Users/Users.js